import generateUrlQuery from '../mixins/generate-url-query';
import getActiveLetter from '../mixins/get-active-letter';

Vue.component('hb-alphabet', {
  template: `
    <ul class="alphabet">
      <li class="alphabet__letter"
          v-for="letter of alphabet"
          :class="{'alphabet__letter--active': letter === getActiveLetter}"
      >
        <router-link :to="generateUrlQuery(getQueryParams(letter))">{{ letter }}</router-link>
      </li>
    </ul>
  `,
  mixins: [
    generateUrlQuery,
    getActiveLetter,
  ],
  data: () => ({
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
  }),
  methods: {
    getQueryParams(letter) {
      return {
        letter: this.getActiveLetter !== letter ? letter : null,
        page: 1
      };
    }
  }
});
